import type { MediaAsset } from 'shared/@generated/models';

export type GallerySlide =
  | { type: 'media'; item: MediaAsset; mediaIndex: number }
  | { type: 'ad'; key: string };

const FIRST_AD_SLIDE_INDEX = 1;
const AD_SLIDE_INTERVAL = 3;

export function getGallerySlideKey(slide: GallerySlide) {
  return slide.type === 'ad' ? slide.key : slide.item.uuid;
}

export function getGallerySlides(items: MediaAsset[], hasAdSlide: boolean): GallerySlide[] {
  const mediaSlides = items.map((item, mediaIndex) => ({
    type: 'media' as const,
    item,
    mediaIndex,
  }));
  const slides: GallerySlide[] = [];

  if (!hasAdSlide) {
    return mediaSlides;
  }

  mediaSlides.forEach((slide, mediaIndex) => {
    slides.push(slide);

    const nextSlideIndex = slides.length;
    const isFirstAdPosition = nextSlideIndex === FIRST_AD_SLIDE_INDEX;
    const isRecurringAdPosition =
      nextSlideIndex > FIRST_AD_SLIDE_INDEX &&
      (nextSlideIndex - FIRST_AD_SLIDE_INDEX) % AD_SLIDE_INTERVAL === 0;

    if (isFirstAdPosition || (isRecurringAdPosition && mediaIndex < mediaSlides.length - 1)) {
      slides.push({ type: 'ad', key: `gallery-ad-${slides.length}` });
    }
  });

  return slides;
}
